<template>
  <div class="pc_order-steps" v-if="isMaxScreen">
    <div class="step-item">
      <img src="@/assets/PC/img/step1.png" alt="" />
      {{$t('PCOrderStep.index.646xagqwff40')}}
    </div>
    <div class="line"></div>
    <div class="step-item">
      <img src="@/assets/PC/img/step2.png" alt="" />
      {{$t('PCOrderStep.index.646xagqwkuw0')}}
    </div>
    <div class="line"></div>
    <div class="step-item">
      <img src="@/assets/PC/img/step3.png" alt="" />
      {{$t('PCOrderStep.index.646xagqwmao0')}}
    </div>
    <div class="line"></div>
    <div class="step-item">
      <img src="@/assets/PC/img/step4.png" alt="" />
      {{$t('PCOrderStep.index.646xagqwmlc0')}}
    </div>
  </div>
  <div v-else class="h5-order-steps">
    <div class="step-item step-left">
      <img src="@/assets/PC/img/step1.png" alt="" />
      {{$t('PCOrderStep.index.646xagqwff40')}}
    </div>
    <img src="@/assets/PC/img/right.png" alt="" class="right" />
    <div class="step-item">
      <img src="@/assets/PC/img/step2.png" alt="" />
      {{$t('PCOrderStep.index.646xagqwkuw0')}}
    </div>
    <img src="@/assets/PC/img/right.png" alt="" class="right" />
    <div class="step-item">
      <img src="@/assets/PC/img/step3.png" alt="" />
      {{$t('PCOrderStep.index.646xagqwmao0')}}
    </div>
    <img src="@/assets/PC/img/right.png" alt="" class="right" />
    <div class="step-item step-right">
      <img src="@/assets/PC/img/step4.png" alt="" />
      {{$t('PCOrderStep.index.646xagqwmlc0')}}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'PCOrderSteps',
  components: {},
  data() {
    return {};
  },
  computed: {
    // 判断是否是PC端
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen;
      }
    })
  },
  methods: {}
};
</script>

<style scoped lang="less">
.pc_order-steps {
  height: 88px;
  background-color: #EEF1FF;
  margin-top: 24px;
  display: flex;
  justify-content: center;
  .step-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 20px;
    img {
      width: 36px;
      height: 36px;
      margin-bottom: 8px;
    }
  }
  .line {
    width: 120px;
    border-top: 1px dashed #8f949d;
    margin-top: 30px;
  }
}

.h5-order-steps {
  height: 120px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // border-top: 1px solid #EBEBEB;
  width: 100%;

  .step-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: var(--text-1, #252629);
    text-align: center;
    font-family: 'PingFang SC';
    font-size: 22px;
    font-style: normal;
    font-weight: 400;
    img {
      width: 48px;
      height: 48px;
    }
  }
  .right {
    width: 32px;
    height: 32px;
    margin: 0 8px;
  }

  .step-left {
    padding-left: 24px;
  }
  .step-right {
    padding-right: 24px;
  }
}
</style>
